module.exports = {
  'Образовательная платформа' : 'Білім беру платформасы',
  'Образовательная платформа АИС EDUS «Электронный колледж» автоматизирует процессы обучения учебных заведений ТиПО РК.' : 'ААЖ EDUS "Электрондық колледж" білім беру платформасы ҚР ТжКБ оқу орындарының оқу процестерін автоматтандырады.',
  'Следите за нами' : 'Бізбен бірге болыңыз',
  'Наши сервисы' : 'Біздің жүйелер',
  'Электронный колледж' : 'Электронды колледж',
  'Электронная школа' : 'Электронды мектеп',
  'Электронный детсад' : 'Электронды балабақша',
  'Дистанционное обучение' : 'Қашықтан оқыту',
  'Онлайн-тестирование' : 'Онлайн тестілеу',
  'Приложения' : 'Қосымшалар',
  'Вы можете установить мобильное приложения для абитуриентов' : 'Сіз талапкерлерге арналған мобильді қосымшаны жүктей аласыз',
  'Политика' : 'Саясат',
  'Пользовательское соглашение' : 'Пайдаланушы келісімі',
  'Выбор региона' : 'Аймақты таңдау',
  'Колледжи' : 'Колледждер',
  'Специальности' : 'Мамандықтар',
  'Информация' : 'Ақпарат',
  'Вопрос-ответ' : 'Сұрақ-жауап',
  'Главная' : 'Басты бет',
  'Мои заявки' : 'Менің өтініштерім',
  'Виртуальный блог' : 'Виртуал блог',
  'Профиль' : 'Профиль',
  'Выход' : 'Шығу',
  'Абитуриент' : 'Талапкер',
  'Кабинет абитуриента' : 'Талапкер кабинеті',
  'welcome' : 'Қош <span class="blue--text text--darken-3">келдіңіз!</span>',
  'вам доступны следующие разделы' : 'Сіз келесі бөлімдерге кіре аласыз',
  'Раздел предназначен для подачи документов, отслеживание их статуса и получения уведомления по заявкам.' : 'Бөлім құжаттарды тапсыруға, олардың статусын бақылауға және өтінімдер бойынша хабарлама алуға арналған.',
  'Перейти' : 'Өту',
  'С помощью данного раздела можете задать вопросы напрямую в приемные комиссии образовательного учреждения.' : 'Осы бөлімнің көмегімен сіз сұрақтарды тікелей оқу орнының қабылдау комиссияларына қоя аласыз.',
  'Ранжирование' : 'Саралау',
  'Результаты конкурса по поданным заявкам будут отображены в этом разделе.' : 'Берілген өтінімдер бойынша конкурс нәтижелері осы бөлімде көрсетілетін болады.',
  'Добавить' : 'Қосу',
  'Посмотреть' : 'Көру',
  'Отозвать заявку' : 'Өтінімді кері қайтару',
  'Выберите ЭЦП' : 'ЭЦҚ таңдаңыз',
  'Введите пароль' : 'Құпия сөзді енгізіңіз',
  'Подписать' : 'Қол қою',
  'Задать вопрос' : 'Сұрақ қою',
  'Обязательное поле' : 'Толтыру міндетті',
  'Отправить' : 'Жіберу',
  // 'Создать новую заявку как родитель' : 'Ата-ана ретінде жаңа қолданба жасаңыз',
  'Отправить запрос ' : 'Сұраныс жіберу',
  'Проверка запроса' : 'Сұранысты тексеру',
  'Чтобы продолжить, нажмите на кнопку ниже. Мы отправим вам сообщение для подтверждения вашей личности.':'Жалғастыру үшін төмендегі түймені басыңыз. Біз сізге жеке басыңызды растау үшін хабарлама жібереміз.',
  'Колледж' : 'Колледж',
  'После подтверждения вашей личности через телефон, нажмите на кнопку ниже для проверки данных.' : 'Телефон арқылы жеке басыңызды растағаннан кейін, деректерді тексеру үшін төмендегі түймені басыңыз.',
  'К сожалению, произошла ошибка при подтверждении вашей личности. Пожалуйста, попробуйте еще раз. Если проблема сохраняется, свяжитесь с поддержкой.' : 'Өкінішке орай, Сіздің жеке басыңызды растау кезінде қате пайда болды. Қайталап көріңіз. Егер мәселе шешілмесе, қолдауға хабарласыңыз.',
  'Вопрос' : 'Сұрақ',
  'статус не подтвержден. Пожалуйста, подтвердите свою личность, затем нажмите на кнопку "Проверка данных".' : 'мәртебесі расталмаған. Жеке басыңызды растаңыз, содан кейін "деректерді тексеру"түймесін басыңыз.',
  'Ваш статус подтвержден! Вы успешно подтвердили свою личность!' : 'Сіздің мәртебеңіз расталды! Сіз өзіңіздің жеке басыңызды сәтті растадыңыз.',
  'Ответ' : 'Жауап',
  'Тип заявки' : 'Өтінім түрі',
  'Профдиагностика' : 'Профдиагностика',
  'Данные' : 'Деректер',
  'Образование' : 'Білім',
  'Квота' : 'Квота',
  'Специальность' : 'Мамандық',
  'Подготовка специалистов среднего звена и прикладного бакалавра' : 'Орта буын және қолданбалы бакалавр мамандарын даярлау',
  'Бесплатное, за счет средств государственного образовательного заказа' : 'Тегін, мемлекеттік білім беру тапсырысы қаражаты есебінен',
  'Продолжить' : 'Жалғастыру',
  'Подготовка квалифицированных рабочих кадров' : 'Білікті жұмысшы кадрларды даярлау',
  'Платное, за счет собственных средств' : 'Ақылы, өз қаражаты есебінен',
  'Пройдите профдиагностику на сайте' : 'Көрсетілген сілтеме арқылы кәсіби диагностикадан өтіңіз ',
  'Назад' : 'Артқа',
  'Далее' : 'Келесі',
  'Данные абитуриента' : 'Талапкер туралы мәліметтер',
  'Данные заявителя' : 'Өтініш беруші туралы мәліметтер',
  'Код' : 'Код',
  'Неправильный формат ИИН' : 'ЖСН форматы дұрыс емес',
  'Контактные данные' : 'Байланыс деректері',
  'Введите корректный E-mail' : 'Дұрыс e-mail енгізіңіз',
  'Неправильный формат телефона' : 'Телефон форматы дұрыс емес',
  'Данные о школе' : 'Мектеп туралы мәліметтер',
  'Неправильный формат' : 'Қате формат',
  'Год не может быть меньше 1901' : 'Жыл 1901 жылдан кем болмауы керек',
  'Год не может быть больше текущего' : 'Жыл ағымдағы жылдан аспауы керек',
  'Дата не может быть позже текущей' : 'Күн ағымдағы күннен кейін болмауы керек',
  'Размер файла не должен превышать 4 Мб' : 'Файл өлшемі 4 Мб аспауы керек',
  '(МАКСИМАЛЬНЫЙ ОБЪЕМ ФАЙЛА НЕ ДОЛЖЕН ПРЕВЫШАТЬ 10 МБ)': '(ФАЙЛ КӨЛЕМІ 10 МБ-ТАН АСПАУЫ КЕРЕК)',
  'Специальность №' : 'Мамандық №',
  'Данные колледжа' : 'Колледж деректері',
  'Профиль колледжа' : 'Колледж профилі',
  'Новости' : 'Жаңалықтар',
  'Госзаказ' : 'Мемлекеттік тапсырыс',
  'Заявки' : 'Өтінімдер',
  'Новые заявки' : 'Жаңа өтінімдер',
  'Все заявки' : 'Барлық өтінімдер',
  'Экзамены' : 'Емтихандар',
  'Все экзамены' : 'Барлық емтихандар',
  'Статистика заявок' : 'Өтінімдер статистикасы',
  'Заполняемость мест' : 'Орындардың толуы',
  'Текущий рейтинг' : 'Ағымдағы рейтинг',
  'Итоги' : 'Нәтижелер',
  'Экспорт данных' : 'Деректерді экспорттау',
  'Госуслуга' : 'Мемлекеттік қызмет',
  'Прием документов' : 'Құжаттарды қабылдау',
  'Платное обучение' : 'Ақылы оқыту',
  'Рабочие квалификации' : 'Жұмысшы біліктілігі',
  'Среднее звено' : 'Орта буын',
  'Общежитие' : 'Жатақхана',
  'Питание' : 'Тамақтану',
  'Экспорт' : 'Экспорт',
  'Обратная связь' : 'Кері байланыс',
  'Новые запросы' : 'Жаңа сұраулар',
  'Все обращения' : 'Барлық өтініштер',
  'Статистика' : 'Статистика',
  'Тех. поддержка' : 'Тех. қолдау',
  'Отправленные' : 'Жіберілген',
  'Написать всем' : 'Барлығына жазу',
  'Новости колледжа' : 'Колледж жаңалықтары',
  'Добавить новость' : 'Жаңалық қосу',
  'Значение поле слишком короткое' : 'Өріс мәні тым қысқа',
  'Нет данных' : 'Деректер табылмады',
  'Удалить' : 'Жою',
  'Закрыть' : 'Жабу',
  'Заявки абитуриентов' : 'Талапкерлердің өтінімдері',
  'Тенденция поступления новых заявок' : 'Жаңа өтінімдерді қабылдау үрдісі',
  'Сегодня' : 'Бүгін',
  'Вчера' : 'Кеше',
  'Всего' : 'Барлығы',
  'Поданные заявки по дням' : 'Күн бойынша берілген өтінімдер',
  'Платно' : 'Ақылы',
  'Уведомить о поступлении заявки' : 'Өтінімнің түскені туралы хабарлау',
  'Принять заявку' : 'Өтінімді қабылдау',
  'Отклонить заявку' : 'Өтінімді қабылдамау',
  'Назначить экзамен' : 'Емтихан тағайындау',
  'Список специальностей' : 'Мамандықтар тізімі',
  'Добавить специальности' : 'Мамандық қосу',
  'Добавить новую специальность' : 'Жаңа мамандық қосу',
  'Фильтры' : 'Сұрыптау',
  'Форма оплаты' : 'Төлем түрі',
  'Тип подготовки' : 'Дайындық түрі',
  'Тип образования' : 'Білім беру түрі',
  'Форма обучения' : 'Оқыту түрі',
  'Подтвердите удаление' : 'Жоюды растаңыз',
  'Отмена' : 'Болдырмау',
  'Редактировать' : 'Өңдеу',
  'Сохранить' : 'Сақтау',
  'Изменить картинку' : 'Суретті өзгерту',
  'Заявки на общежитие' : 'Жатақханаға өтінімдер',
  'Заявки на питание' : 'Тамақтануға өтінімдер',
  'Новый' : 'Жаңа',
  'Закрыт' : 'Жабық',
  'Закрыт с ответом' : 'Жауап берілді',
  'Ответить' : 'Жауап беру',
  'Выберите ЭЦП физического лица' : 'Жеке тұлғаның ЭЦҚ таңдаңыз',
  'Выберите ЭЦП юридического лица' : 'Заңды тұлғаның ЭЦҚ таңдаңыз',
  'sign_as_abiturient' : '<span class="green--text text-darken-1">Абитуриенттің</span> кабинетіне кіру',
  'sign_as_college' : '<span class="green--text text-darken-1">Колледждің</span> кабинетіне кіру',
  'sign_as_department' : '<span class="green--text text-darken-1">ТжКБ</span> кабинетіне кіру',
  'Войти в систему' : 'Жүйеге кіру',
  'Войти' : 'Кіру',
  'abiturient_login_text' : '<p>Жеке кабинетке кіру азаматтардың электрондық-цифрлық қолтаңбасы (ЭЦҚ) арқылы жүзеге асырылады. Қажет болған жағдайда жүйемен жұмыс істеу жөніндегі нұсқаулықты <a href="https://www.youtube.com/watch?v=Ilipo-v6zBo" target="_blank">көре аласыз</a> немесе <a href="/portal/static/abiturient_instruction_kz.docx" download>жүктей аласыз</a>.</p> ИС мемлекеттік тапсырыс бойынша тегін оқуға колледжге түсу үшін құжаттар тапсыруға және олардың статусын қадағалауға мүмкіндік береді. Қорытынды нәтижелер рейтинг бөлімінде көрсетіледі. Қабылдау комиссиясына қызықтыратын сұрақтарды қою мүмкіндігі бар.</p>',
  'college_login_text' : '<p>Жеке кабинетке кіру заң мекемесінің электрондық-цифрлық қолтаңбасы (ЭЦҚ) арқылы жүзеге асырылады. Қажет болған жағдайда жүйемен жұмыс істеу жөніндегі нұсқаулықты <a href="#">көре аласыз</a> немесе <a href="/portal/static/comission_instruction_kz.pdf">жүктей аласыз</a>.</p><p>Негізгі функционал келіп түскен өтінімдерді қарау және өңдеу, арнайы емтихандарды тағайындау және қабылдау бойынша консультациялар болып табылады.</p>',
  'department_login_text' : '<p>Жеке кабинетке кіру заң мекемесінің электрондық-цифрлық қолтаңбасы (ЭЦҚ) арқылы жүзеге асырылады. Қажет болған жағдайда жүйемен жұмыс істеу жөніндегі нұсқаулықты <a href="#">көре аласыз</a> немесе <a href="#">жүктей аласыз</a>.</p><p>Жүйеде өтінімдер мониторингі бар, өзекті статистикалық деректер, ведомстволық бағынысты ұйымдардың (колледждердің) мемлекеттік тапсырысы бойынша бос орындар саны көрсетіледі. Виртуалды блог бар.</p>',
  'Управление колледжом' : 'Колледжді басқару',
  'sign_for' : '<span class="blue--text text--darken-3">Мекеме</span> ретінде кіру',
  'Вход в кабинет абитуриента' : 'Талапкер кабинетіне кіру',
  'ИС позволяет подавать документы для поступления в колледж на бесплатное обучение по государственному заказу и отслеживать их статус. Итоговые результаты отображаются в разделе ранжирование. Есть возможность задать интересующие вопросы в приемную комиссию.' : 'АЖ мемлекеттік тапсырыс бойынша тегін оқуға колледжге түсу үшін құжаттарды тапсыруға және олардың статусын бақылауға мүмкіндік береді. Қорытынды нәтижелер рейтинг бөлімінде көрсетіледі. Қабылдау комиссиясына қызықтыратын сұрақтарды қою мүмкіндігі бар.',
  'Вход в кабинет' : 'Кабинетке кіру',
  'Приемная комиссия колледжа' : 'Колледждің қабылдау комиссиясы',
  'Приемная комиссия колледжа может отслеживать поступающие заявки от абитуриентов. Система позволяет управлять процессами приема и отказа в колледж. Требуется ЭЦП юридического учреждения.' : 'Колледждің қабылдау комиссиясы талапкерлерден келіп түскен өтінімдерді қадағалай алады. Жүйе Колледжге қабылдау және бас тарту процестерін басқаруға мүмкіндік береді. Заң мекемесінің ЭЦҚ қажет.',
  'Управление ТиПО' : 'ТжКБ Басқармасы',
  'Вход в кабинет для Управления Образования (ТиПО) позволяет проводить мониторинг по приему абитуриентов подведомственных организаций (колледжей). Отображаются актуальные статистические данные. Имеется виртуальный блог.' : 'Білім беру (ТжКБ) басқармасының кабинетіне кіру ведомстволық бағынысты ұйымдардың (колледждердің) талапкерлерін қабылдау бойынша мониторинг жүргізуге мүмкіндік береді. Өзекті статистикалық деректер көрсетіледі. Виртуалды блог бар.',
  'Просмотр заявки' : 'Өтінімді қарау',
  'Заявка успешно отозвана.' : 'Өтінім сәтті кері қайтарып алынды.',
  'Регион' : 'Аймақ',
  'Заголовок вопроса' : 'Сұрақтың тақырыбы',
  'Ваш вопрос' : 'Сіздің сұрақ',
  'Я получил(а) и ознакомился(ась) с результатами профдиагностики' : 'Мен кәсіптік диагностиканың нәтижелерін қабылдадым және олармен таныстым',
  'Тип заявителя' : 'Өтініш берушінің түрі',
  'Фамилия' : 'Тегі',
  'Имя' : 'Аты',
  'Отчество' : 'Әкесінің аты',
  'Дата рождения' : 'Туған күні',
  'Статус гражданина' : 'Азаматтық статусы',
  'Национальность' : 'Ұлты',
  'ИИН' : 'ЖСН',
  'Электронная почта' : 'Электронды пошта',
  'Номер телефона' : 'Телефон нөмірі',
  'Номер телефона родителя' : 'Ата-анасының телефон нөмірі',
  'Страна' : 'Мемлекет',
  'Школа' : 'Мектеп',
  'Год окончания' : 'Бітірген жылы',
  'Тип документа' : 'Құжат түрі',
  'Документ об образовании' : 'Білім туралы құжат',
  'Тип льготы' : 'Жеңілдік түрі',
  'Документ подтверждающий льготу' : 'Жеңілдікті растайтын құжат',
  'Организация образования' : 'Білім беру ұйымы',
  'Язык обучения' : 'Оқыту тілі',
  'Новая заявка' : 'Жаңа өтінім',
  'Другое' : 'Басқа',
  'Без льготы' : 'Льготасыз',
  'Заявка успешно отправлена' : 'Өтінім сәтті жіберілді',
  'Ваш ответ' : 'Сіздің жауап',
  'Язык' : 'Тіл',
  'Заголовок' : 'Тақырыбы',
  'Основной текст' : 'Негізгі мәтін',
  'Картинка' : 'Сурет',
  'Вы действительно хотите удалить эту новость?' : 'Сіз бұл жаңалықты жойғыңыз келе ме?',
  'Причина отказа' : 'Бас тарту себебі',
  'Уточнение причины отказа на русском языке' : 'Бас тарту себебін орыс тілінде нақтылау',
  'Уточнение причины отказа на казахском языке' : 'Бас тарту себебін қазақ тілінде нақтылау',
  'Перечень отсутствующих документов на русском языке' : 'Орыс тілінде жоқ құжаттардың тізбесі',
  'Перечень отсутствующих документов на казахском языке' : 'Қазақ тілінде жоқ құжаттардың тізбесі',
  'Заявка успешно обработана.' : 'Өтінім сәтті өңделді.',
  'Количество мест' : 'Орын саны',
  'Изменения успешно сохранены' : 'Өзгерістер сәтті сақталды',
  'Номер общежития' : 'Жатақхана нөмірі',
  'Адрес общежития на казахском' : 'Жатақхананың мекен-жайы қазақ тілінде',
  'Адрес общежития на русском' : 'Жатақхананың мекен-жайы орыс тілінде',
  'На какой учебный год' : 'Қай оқу жылына',
  'Пароль' : 'Құпия сөз',
  'Первый обязательный предмет': 'Бірінші міндетті пән',
  'Второй обязательный предмет': 'Екінші міндетті пән',
  'Настроить': 'Баптау',
  'Первый профильный предмет': 'Бірінші бейіндік пән',
  'Второй профильный предмет': 'Екінші бейіндік пән',
  'Создать новую заявку' : 'Жаңа өтінім беру',
  'Пароль от ЭЦП' : 'ЭЦҚ құпиясөзі',
  'Введите номер расписки' : 'Қолхат нөмірін енгізіңіз',
  'Введите дату расписки' : 'Қолхат берілген күнді енгізіңіз',
  'Добавить новую заявку' : 'Жаңа өтінім қосу',
  'Поиск по ИИН' : 'ЖСН бойынша іздеу',
  'Открыть в новом окне' : 'Жаңа терезеде ашу',
  'Назначение экзамена': 'Емтихан тағайындау',
  'Некорректные заявки': 'Қате өтінімдер',
  'Редактировать количество мест' : 'Орын санын өңдеу',
  'Минимальное количество мест: 1' : 'Минималды орын саны: 1',
  'Экспортировать в Excel' : 'Excel-ге экспорттау',
  'Выставить оценки': 'Баға қою',
  'Передача персональных данных третьим лицам преследуется законом РК': 'Жеке деректерді үшінші тұлғаларға беру ҚР Заңымен қудаланады',
  'Настройка формулы СКБ': 'ОКБ формуласын бекіту',
  'Оценки СКБ': 'ОКБ бағалары',
  'Выставить оценки СКБ': 'ОКБ бағаларын қою',
  'Выбраны одинаковые предметы': 'Бірдей пәндер таңдалған',
  'Настроите формулу СКБ': 'ОКБ формуласын бекітіңіз',
  'Это заявка отправлено на неосвоенное место. Если нажимаете кнопку принять, заявка принимается сразу. Просим быть внимательными!': 'Бұл бос орынға тапсырылған өтініш. Егер қабылдау батырмасын бассаңыз, талапкер бірден қабылданады. Мұқият болуыңызды сұраймыз.',
  'Отменить решение': 'Шешімді жою',
  'Ваш QR': 'Сіздің QR',
  'Для входа в мобильное приложение': 'Мобильді қосымшаға кіру үшін',
  'Медицинская справка 075/У (086)': '075/У (086) медициналық анықтамасы',
  'Медицинские справки': 'Медициналық анықтама',
  'Номер телефона абитуриента': 'Талапкер телефон нөмірі',
  'Целевой грант': 'Мақсатты грант',
  'Хочу участвовать в целевом гранте': 'Мақсатты грантқа қатысқым келеді',
  'Из них целевой грант': 'Оның ішінде мақсатты грант',
  'Целевой грант не может быть больше чем количество мест': 'Мақсатты грант орын санынан артық бола алмайды',
  'Добавить заявку' : 'Жаңа өтінім қосу',
  'Добавить заявку по целевому гранту': 'Мақсатты грант бойынша өтінім қосу',
  'Управление заявками': 'Өтінімдерді басқару',
  'Отозвать': 'Кері қайтару',
  'С Единой инструкцией по проведению Конкурса ознакомлен(-а)' : 'Конкурс өткізу бойынша Бірыңғай нұсқаулықпен таныстым',
  'Даю согласие на сбор, обработку персональных данных' : 'Дербес деректерді жинақтауға, өңдеуге келісім беремін',
  'Распечатать заявку': 'Өтінішті басып шығару',
  'Форма электронного заявления': 'Электрондық өтінім формасы',
  'Подано через ИС Абитуриент EDUS': 'АЖ Абитуриент EDUS арқылы тапсырылды',
  'Фамилия, имя, отчество поступающего': 'Түсуушінің тегі, аты, әкесінің аты',
  'Контактный телефон (с указанием номера мамы, если абитуриент - ребенок)': 'Байланыс телефоны (абитуриент бала болса, анасының нөмірін көрсетумен)',
  'Код и наименование': 'Коды және атауы',
  'специальности и организации ТиППО': 'мамандығы және ТКЖО ұйымы',
  'ТиППО': 'ТКЖО',
  'Базовое образование': 'Негізгі білім',
  'Предусматривается квота приема': 'Қабылдау квотасы қарастырылған',
  'Добавить еще одну специальность': 'Тағы бір мамандық қосу',
  'Выставить оценки экзамена': 'Емтихан бағасын қою',
  'В обработке': 'Өңделуде',
  'Принятые': 'Қабылданған',
  'Отказанные': 'Қабылданбаған',
  'Отозванные': 'Қайтарып алынған',
  'Назначить собеседование по целевому гранту': 'Мақсатты грант бойынша әңгімелесуді тағайындау',
  'ФИО': 'АТЫ-ЖӨНІ',
  'Квота приема': 'Қабылдау квотасы',
  'Статус': 'Мәртебе',
  'Подано через': 'Арқылы берілген',
  'Источник': 'Көзі',
  'Есть': 'Бар',
  'Нет': 'Жоқ',
  'Заявка': 'Өтінім',
  'Заявка в ручную': 'Қолмен берілетін өтінім',
  'Загрузить данные с mektep.edu.kz': 'Деректерді mektep.edu.kz жүктеу',
  'Данные о детях, достигших выпускного возраста, отсутствуют в базе.': 'Бітіруші жасқа толған балалар туралы деректер базада жоқ.',
  'Подтверждение по SMS': 'SMS арқылы растау',
  'Мы отправили вам сообщение для подтверждения вашей личности. После подтверждения, нажмите на кнопку "Обновить".': 'Жеке басыңызды растау үшін сізге хабар жібердік. Растағаннан кейін «Жаңарту» түймешігін басыңыз.',
  'Обновить': 'Жаңарту',
  'Данные не найдены': 'Деректер табылмады',
  'Выберите способ подачи заявки': 'Өтінім беру әдісін таңдаңыз',
  'Как абитуриент': 'Талапкер ретінде',
  'Подать заявку на поступление от своего имени': 'Өз атыңыздан колледжге түсуге өтінім беру',
  'Через ГБДФЛ': 'ТҚ МДБ арқылы',
  'Подать заявку на поступление за ребёнка через подтверждение по SMS': 'SMS арқылы растаумен баланың атынан колледжге түсуге өтінім беру',
  'Назад к выбору способа': 'Әдіс таңдауға оралу',
  'Выберите детей': 'Балаларды таңдаңыз',
  'Выбор ребёнка': 'Бала таңдау',
  'Выберите способ авторизации': 'Авторизация әдісін таңдаңыз',
  'Вход через ЭЦП': 'ЭЦҚ арқылы кіру',
  'Авторизация с помощью электронно-цифровой подписи физического лица': 'Жеке тұлғаның электрондық-цифрлық қолтаңбасы арқылы авторизация',
  'Вход по паролю': 'Құпия сөзбен кіру',
  'Авторизация с помощью логина и пароля личного кабинета': 'Жеке кабинеттің логині мен құпия сөзі арқылы авторизация',
  'Логин': 'Логин',
  'Ошибка авторизации': 'Авторизация қатесі',
  'Назад к выбору способа авторизации': 'Авторизация әдісін таңдауға оралу',
  'Информация о заявке': 'Өтінім туралы ақпарат',
  'Номер заявки': 'Өтінім нөмірі',
  'Статус заявки': 'Өтінім мәртебесі',
  'Основные персональные данные Абитуриента': 'Талапкердің негізгі жеке деректері',
  'День рождения': 'Туған күні',
  'Данные об образовании': 'Білім туралы мәліметтер',
  'Тип документа о полученном образовании': 'Алынған білім туралы құжат түрі',
  'Страна окончания школы': 'Мектеп бітірген елі',
  'Регион окончания школы': 'Мектеп бітірген аймағы',
  'Наименование школы': 'Мектеп атауы',
  'Год окончания (выпуска)': 'Бітіру (шығу) жылы',
  'Тип квоты приема': 'Қабылдау квотасының түрі',
  'Документ о квоте': 'Квота туралы құжат',
  'Квалификация №': 'Біліктілік №',
  'Наименование квалификации': 'Біліктілік атауы',
  'Код квалификации': 'Біліктілік коды',
  'Наименование колледжа': 'Колледж атауы',
  'БИН колледжа': 'Колледж БСН',
  'Участвует в целевом гранте': 'Мақсатты грантқа қатысады',
  'Экзамен': 'Емтихан',
  'Да': 'Иә',
  'Подтвердить': 'Растау',
  'Вы действительно хотите отозвать заявку?': 'Сіз өтінімді кері қайтарғыңыз келетініне сенімдісіз бе?',
  'Редактирование заявки': 'Өтінімді өңдеу',
  'Нет изменений для сохранения': 'Сақтау үшін өзгерістер жоқ',
  'Заявка успешно обновлена': 'Өтінім сәтті жаңартылды',
  'Редактирование заявки недоступно': 'Өтінімді өңдеу мүмкін емес',
  'Размер файла не должен превышать 10 Мб': 'Файл өлшемі 10 Мб-тан аспауы керек',
  'Квалификации': 'Біліктіліктер',
  'Не удалось загрузить файл': 'Файлды жүктеу мүмкін болмады',
  'Сменить пароль': 'Құпия сөзді өзгерту',
  'Смена пароля': 'Құпия сөзді өзгерту',
  'Новый пароль': 'Жаңа құпия сөз',
  'Пароль успешно изменен': 'Құпия сөз сәтті өзгертілді',
  'Создание логина и пароля': 'Логин мен құпия сөзді жасау',
  'У вас пока нет логина и пароля. Создайте их для входа по паролю в личный кабинет.': 'Сізде әлі логин мен құпия сөз жоқ. Жеке кабинетке құпия сөзбен кіру үшін оларды жасаңыз.',
  'Логин и пароль успешно созданы': 'Логин мен құпия сөз сәтті жасалды',
  'Неразвитые места': 'Дамымаған орындар',
  'Общее количество мест': 'Орындардың жалпы саны',
  'Оставшиеся места': 'Қалған орындар',
  'Код специальности': 'Мамандық коды',
  'Языковая группа': 'Тіл тобы',
  'Остальные предметы': 'Басқа пәндер',
  '+ Добавить предмет': '+ Пән қосу',
  'Предмет': 'Пән',
  'Учебное заведение': 'Оқу орны',
  'Тип квоты': 'Квота түрі',
  'Назначение экзаменов': 'Емтихан тағайындау',
  'Дата проведения': 'Өткізу күні',
  'Время (HH:mm)': 'Уақыт (СС:мм)',
  'Укажите время в формате ЧЧ:мм': 'Уақытты СС:мм форматында енгізіңіз',
  'Место проведения': 'Өткізу орны',
  'Назначить': 'Тағайындау',
  'Оценка экзаменов': 'Емтихан бағалау',
  'Оценки аттестата': 'Аттестат бағалары',
  'Редактирование оценок аттестата': 'Аттестат бағаларын өңдеу',
  'Оценки аттестата обновлены': 'Аттестат бағалары жаңартылды',
  'Выберите ЭЦП и введите пароль': 'ЭЦҚ таңдап, құпия сөзді енгізіңіз',
  'Выбрать': 'Таңдау',
  'Дата и время': 'Күні мен уақыты',
  'СБА': 'ОАБ',
  'СКБ': 'ОКБ',
  'Общая статистика': 'Жалпы статистика',
  'Статистика по квотам': 'Квоталар бойынша статистика',
  'Выделенные места и Поступившие заявки': 'Бөлінген орындар және түскен өтінімдер',
  'Количество выделенных мест': 'Бөлінген орындар саны',
  'Выбери ребенка': 'Баланы таңдаңыз',
  'Неделя': 'Апта',
  'Месяц': 'Ай',
  'Все': 'Барлығы',
  'Квалификация': 'Біліктілік',
  'Тип оплаты': 'Төлем түрі',
  'Обучение по государственному заказу': 'Мемлекеттік тапсырыс бойынша оқу',
  'Государственный заказ': 'Мемлекеттік тапсырыс',
  'Категория заявителя': 'Талапкер санаты',
  'Номер телефона родителей': 'Ата-ананың телефон нөмірі',
  'Личные данные': 'Жеке деректер',
  'Гражданство': 'Азаматтық',
  'Документы': 'Құжаттар',
  'Родитель': 'Ата-ана',
  'Дата': 'Күні',
  'Рассмотрение заявки': 'Өтінімді қарау',
  'Оценивание': 'Бағалау',
  'Отказать': 'Бас тарту',
  'Отказ в заявке': 'Өтінімнен бас тарту',
  'Заявка отклонена.': 'Өтінім қабылданбады.',
  'Принять': 'Қабылдау',
  'Документ не найден': 'Құжат табылмады',
  'Отказать в приёме заявки?': 'Өтінімді қабылдамау керек пе?',
  'Поставить оценку экзамена': 'Емтихан бағасын қою',
	'Поставить оценку СКБ': 'ОКБ бағасын қою',
  'Приемная комиссия': 'Қабылдау комиссиясы',
  'Казахстан': 'Қазақстан',
  'Репатриант': 'Қандас',
  'Оралман': 'Оралман',
  'Резидент РК': 'ҚР резиденті',
  'Гражданин РК': 'ҚР азаматы',
  'Наименование': 'Атауы',
  'Форма собственности': 'Меншік нысаны',
  'Адрес': 'Мекенжай',
  'Телефон': 'Телефон',
  'Пункт образования': 'Білім беру пункті',
  'Тип организации': 'Ұйым түрі',
  'БИН': 'БИН',
  'Частная': 'Жекеменшік',
  'Государственная': 'Мемлекеттік',
  'Республиканский': 'Республикалық',
  'Государственное учреждение': 'Мемлекеттік мекеме',
  'Частное учреждение': 'Жеке мекеме',
  'Оценки СКБ': 'ОКБ бағалары',
  'Ожидающие итогов конкурса': 'Конкурс нәтижелерін күтуде',
  'Не прошедшие конкурс': 'Конкурстан өтпегендер',
  'Прошедшие конкурс': 'Конкурстан өткендер',
  'СКБ формула не настроена!': 'ОКБ формуласы бапталмаған!'
}